import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const createAnnouncement = async (
	payload: FormData
): Promise<IAnnouncement> => {
	const response = await cmsClient.post<IAnnouncement>(
		"/announcements/",
		payload,
		{
			headers: { "Content-Type": "multipart/form-data" }
		}
	);
	return response.data;
};

const useCreateAnnouncement = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast
				type="Success"
				message="Announcement created successfully"
			/>,
			{ hideProgressBar: true }
		);
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["announcements"]);
	};

	const onError = (error: unknown) => {
		const axiosError = error as AxiosError;
		const message =
			axiosError?.response?.status === 409
				? "This announcement could not be created due to a conflict."
				: "Something went wrong, try again";
		toast.error(<CustomToast type="Error" message={message} />, {
			hideProgressBar: true
		});
	};

	const mutation = useMutation(createAnnouncement, {
		onError,
		onSuccess,
		onSettled
	});
	return mutation;
};

export default useCreateAnnouncement;
